export default "__VITE_ASSET__kk0cp4jb__"